import { Loader } from '@seen/react'
import { type JSX, lazy, Suspense } from 'react'

// Admin-only route (/practitioners/:practitionerId). This page and
// PractitionerManagerPage are the only consumers of PractitionerCreateForm, so
// splitting both moves that form out of the initial chunk too.
const PractitionerDetailPageImpl = lazy(() =>
  import('#src/pages/PractitionerDetailPageImpl.tsx').then((m) => ({
    default: m.PractitionerDetailPageImpl,
  }))
)

export function PractitionerDetailPage(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <PractitionerDetailPageImpl />
    </Suspense>
  )
}
